// src/pages/Destinations.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PJS = { fontFamily:"'Plus Jakarta Sans', sans-serif" };
const S   = { fontFamily:"'DM Sans', sans-serif" };

const DESTINATIONS = [
  // Europe
  { name:"Tenerife",     country:"Spain",       region:"Europe",       image:"/images/destinations/tenerife.jpg",     desc:"Year-round sunshine, volcanic landscapes and stunning beaches on Spain's largest island.",     popular:true  },
  { name:"Majorca",      country:"Spain",       region:"Europe",       image:"/images/destinations/majorca.jpg",      desc:"Beautiful coves, vibrant nightlife and medieval old towns in the Balearic Islands.",              popular:true  },
  { name:"Lanzarote",    country:"Spain",       region:"Europe",       image:"/images/destinations/lanzarote.jpg",    desc:"Dramatic volcanic scenery, white villages and golden beaches in the Canary Islands.",              popular:false },
  { name:"Gran Canaria", country:"Spain",       region:"Europe",       image:"/images/destinations/grancanaria.jpg",  desc:"A continent in miniature — lush forests, sand dunes and some of the best beaches in Europe.",        popular:false },
  { name:"Ibiza",        country:"Spain",       region:"Europe",       image:"/images/destinations/ibiza.jpg",        desc:"World-famous nightlife alongside serene coves, pine forests and stunning sunsets.",                  popular:false },
  { name:"Fuerteventura",country:"Spain",       region:"Europe",       image:"/images/destinations/fuerteventura.jpg",desc:"Europe's best surf beaches, vast sand dunes and turquoise lagoons.",                              popular:false },
  { name:"Algarve",      country:"Portugal",    region:"Europe",       image:"/images/destinations/algarve.jpg",      desc:"Dramatic cliffs, golden sands and world-class golf along Portugal's stunning southern coast.",       popular:false },
  { name:"Rhodes",       country:"Greece",      region:"Europe",       image:"/images/destinations/rhodes.jpg",       desc:"Ancient ruins, medieval old town and crystal-clear Aegean waters on Greece's largest island.",       popular:false },
  { name:"Corfu",        country:"Greece",      region:"Europe",       image:"/images/destinations/corfu.jpg",        desc:"Lush green hills, turquoise bays and Venetian architecture in the Ionian Sea.",                     popular:false },
  { name:"Zante",        country:"Greece",      region:"Europe",       image:"/images/destinations/zante.jpg",        desc:"Shipwreck beach, sea turtles and electric nightlife on this iconic Greek island.",                   popular:false },
  { name:"Cyprus",       country:"Cyprus",      region:"Europe",       image:"/images/destinations/cyprus.jpg",       desc:"Ancient history, gorgeous beaches and incredible cuisine on the island of Aphrodite.",               popular:false },
  { name:"Barcelona",    country:"Spain",       region:"Europe",       image:"/images/destinations/barcelona.jpg",    desc:"Gaudí architecture, vibrant food scene and beautiful beaches in Spain's coolest city.",              popular:true  },
  { name:"Paris",        country:"France",      region:"Europe",       image:"/images/destinations/paris.jpg",        desc:"The Eiffel Tower, world-class cuisine and the most romantic city on earth.",                         popular:true  },
  { name:"Rome",         country:"Italy",       region:"Europe",       image:"/images/destinations/rome.jpg",         desc:"The Colosseum, Vatican City, pasta and gelato — the Eternal City never disappoints.",                popular:false },
  { name:"Lisbon",       country:"Portugal",    region:"Europe",       image:"/images/destinations/lisbon.jpg",       desc:"Trams, tiles, tascas and some of the best nightlife in Europe on seven hilly hills.",                popular:false },
  { name:"Amsterdam",    country:"Netherlands", region:"Europe",       image:"/images/destinations/amsterdam.jpg",    desc:"Canal houses, world-class museums, cycling culture and vibrant nightlife.",                          popular:false },
  // Middle East / Africa
  { name:"Dubai",        country:"UAE",         region:"Middle East",  image:"/images/destinations/dubai.jpg",        desc:"Futuristic skyline, luxury shopping, desert adventures and year-round sunshine.",                    popular:true  },
  { name:"Marrakech",    country:"Morocco",     region:"Africa",       image:"/images/destinations/marrakech.jpg",    desc:"Ancient medina, souks, riads and the Atlas Mountains just a short drive away.",                     popular:false },
  // Asia / Pacific
  { name:"Maldives",     country:"Maldives",    region:"Indian Ocean", image:"/images/destinations/maldives.jpg",     desc:"Overwater bungalows, coral reefs and the clearest blue waters on the planet.",                      popular:true  },
  { name:"Phuket",       country:"Thailand",    region:"Asia",         image:"/images/destinations/phuket.jpg",       desc:"Thai temples, elephant sanctuaries, stunning beaches and world-famous street food.",                  popular:true  },
  { name:"Bali",         country:"Indonesia",   region:"Asia",         image:"/images/destinations/bali.jpg",         desc:"Rice terraces, Hindu temples, surf beaches and incredible spa culture.",                             popular:false },
  { name:"Cancun",       country:"Mexico",      region:"Americas",     image:"/images/destinations/cancun.jpg",       desc:"Caribbean beaches, Maya ruins, cenotes and all-inclusive resorts.",                                  popular:false },
];

const REGIONS = ["All", "Europe", "Middle East", "Africa", "Indian Ocean", "Asia", "Americas"];

function DestCard({ dest, onBook }) {
  const [err, setErr] = useState(false);
  const fb = "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&h=280&fit=crop&q=80";

  return (
    <div style={{
      background:"#fff", border:"1px solid #e5e5e5", borderRadius:12,
      overflow:"hidden", cursor:"pointer", boxShadow:"0 1px 4px rgba(0,0,0,.06)",
      transition:"box-shadow .2s, transform .2s", display:"flex", flexDirection:"column",
    }}
      onMouseEnter={e=>{ e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,.12)"; e.currentTarget.style.transform="translateY(-3px)"; }}
      onMouseLeave={e=>{ e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.06)"; e.currentTarget.style.transform="none"; }}
      onClick={() => onBook(dest.name)}
    >
      <div style={{ position:"relative", height:185, overflow:"hidden" }}>
        <img
          src={err ? fb : dest.image}
          alt={dest.name}
          style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", transition:"transform .4s" }}
          onError={() => setErr(true)}
          loading="lazy"
        />
        <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top, rgba(0,0,0,.55) 0%, transparent 55%)" }} />
        {dest.popular && (
          <div style={{ position:"absolute", top:10, right:10, background:"#E53935", color:"#fff", fontSize:11, fontWeight:800, padding:"3px 8px", borderRadius:5, ...PJS }}>
            Popular
          </div>
        )}
        <div style={{ position:"absolute", bottom:12, left:13 }}>
          <div style={{ color:"#fff", fontSize:18, fontWeight:900, ...PJS }}>{dest.name}</div>
          <div style={{ color:"rgba(255,255,255,.82)", fontSize:13, ...S }}>{dest.country}</div>
        </div>
      </div>
      <div style={{ padding:"13px 15px", flex:1 }}>
        <p style={{ fontSize:13.5, color:"#555", lineHeight:1.6, margin:"0 0 12px", ...S }}>{dest.desc}</p>
        <button
          onClick={e=>{ e.stopPropagation(); onBook(dest.name); }}
          style={{ background:"#1565C0", color:"#fff", border:"none", padding:"9px 16px", borderRadius:7, fontWeight:700, fontSize:14, cursor:"pointer", ...PJS, transition:"background .2s" }}
          onMouseEnter={e=>e.target.style.background="#0d47a1"}
          onMouseLeave={e=>e.target.style.background="#1565C0"}
        >
          Search hotels
        </button>
      </div>
    </div>
  );
}

export default function Destinations() {
  const navigate = useNavigate();
  const [region, setRegion] = useState("All");
  const [search, setSearch] = useState("");

  const ci = new Date(Date.now()+45*86400000).toISOString().split("T")[0];
  const co = new Date(Date.now()+52*86400000).toISOString().split("T")[0];

  const onBook = name => navigate(`/hotels?city=${encodeURIComponent(name)}&checkIn=${ci}&checkOut=${co}&guests=2`);

  const filtered = DESTINATIONS.filter(d => {
    const matchRegion = region === "All" || d.region === region;
    const matchSearch = !search || `${d.name} ${d.country}`.toLowerCase().includes(search.toLowerCase());
    return matchRegion && matchSearch;
  });

  const popular = filtered.filter(d => d.popular);
  const rest    = filtered.filter(d => !d.popular);

  return (
    <>
      <Navbar />

      {/* Header */}
      <div style={{ background:"linear-gradient(135deg,#0d47a1,#1565C0,#1976D2)", padding:"44px 20px 52px" }}>
        <div style={{ maxWidth:1000, margin:"0 auto", textAlign:"center" }}>
          <div style={{ display:"flex", gap:6, alignItems:"center", justifyContent:"center", marginBottom:16, fontSize:13 }}>
            <Link to="/" style={{ color:"rgba(255,255,255,.7)", textDecoration:"none" }}>Home</Link>
            <span style={{ color:"rgba(255,255,255,.3)" }}>›</span>
            <span style={{ color:"#fff", fontWeight:600 }}>Destinations</span>
          </div>
          <h1 style={{ fontSize:"clamp(24px,4.5vw,40px)", fontWeight:900, color:"#fff", margin:"0 0 12px", ...PJS }}>
            Where do you want to go?
          </h1>
          <p style={{ color:"rgba(255,255,255,.82)", fontSize:16, marginBottom:28, ...S }}>
            Explore 20+ stunning destinations — from Canary Islands sun to Maldives luxury
          </p>
          {/* Search */}
          <div style={{ display:"flex", gap:0, maxWidth:500, margin:"0 auto" }}>
            <input
              type="text"
              placeholder="Search destinations..."
              value={search}
              onChange={e=>setSearch(e.target.value)}
              style={{ flex:1, padding:"13px 16px", border:"none", borderRadius:"8px 0 0 8px", fontSize:15, fontFamily:"inherit", outline:"none" }}
            />
            <button style={{ padding:"13px 20px", background:"#2E7D32", color:"#fff", border:"none", borderRadius:"0 8px 8px 0", fontWeight:800, fontSize:15, cursor:"pointer", ...PJS }}>
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Region tabs */}
      <div style={{ background:"#fff", borderBottom:"1px solid #e5e5e5", overflowX:"auto" }}>
        <div style={{ maxWidth:1240, margin:"0 auto", padding:"0 20px", display:"flex", gap:2 }}>
          {REGIONS.map(r => (
            <button
              key={r}
              onClick={() => setRegion(r)}
              style={{
                padding:"13px 18px", background:"none", border:"none",
                borderBottom: region===r ? "3px solid #1565C0" : "3px solid transparent",
                fontSize:14, fontWeight: region===r ? 800 : 500,
                color: region===r ? "#1565C0" : "#555",
                cursor:"pointer", whiteSpace:"nowrap", ...S,
                transition:"color .15s, border-color .15s",
              }}
            >{r}</button>
          ))}
        </div>
      </div>

      <div style={{ maxWidth:1240, margin:"0 auto", padding:"32px 20px 100px" }}>

        {/* Popular */}
        {popular.length > 0 && region === "All" && (
          <div style={{ marginBottom:40 }}>
            <h2 style={{ fontSize:22, fontWeight:800, color:"#1a1a1a", marginBottom:6, ...PJS }}>Popular destinations</h2>
            <p style={{ fontSize:14, color:"#888", marginBottom:20, ...S }}>Our most searched and booked holidays</p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:20 }}>
              {popular.map(d => <DestCard key={d.name} dest={d} onBook={onBook} />)}
            </div>
          </div>
        )}

        {/* Rest / all filtered */}
        {(region !== "All" ? filtered : rest).length > 0 && (
          <div>
            {region === "All" && (
              <>
                <h2 style={{ fontSize:22, fontWeight:800, color:"#1a1a1a", marginBottom:6, ...PJS }}>All destinations</h2>
                <p style={{ fontSize:14, color:"#888", marginBottom:20, ...S }}>{filtered.length} destinations available</p>
              </>
            )}
            {region !== "All" && (
              <>
                <h2 style={{ fontSize:22, fontWeight:800, color:"#1a1a1a", marginBottom:6, ...PJS }}>{region}</h2>
                <p style={{ fontSize:14, color:"#888", marginBottom:20, ...S }}>{filtered.length} destination{filtered.length!==1?"s":""}</p>
              </>
            )}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:20 }}>
              {(region !== "All" ? filtered : rest).map(d => <DestCard key={d.name} dest={d} onBook={onBook} />)}
            </div>
          </div>
        )}

        {filtered.length === 0 && (
          <div style={{ textAlign:"center", padding:"60px 20px", color:"#888" }}>
            <div style={{ fontSize:44, marginBottom:14, opacity:.3 }}>&#9744;</div>
            <p style={{ fontWeight:800, fontSize:18, marginBottom:6, color:"#444", ...PJS }}>No destinations found</p>
            <p style={{ fontSize:14, ...S }}>Try a different search or select "All" regions.</p>
            <button onClick={()=>{setRegion("All");setSearch("");}} style={{ marginTop:16, padding:"10px 22px", background:"#1565C0", color:"#fff", border:"none", borderRadius:8, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
              Show all
            </button>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}